// React
import React, { useEffect, useState, memo, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import { PrimaryButton } from '../../../msreact-kit/html-components/button';
import Footer from '../../BaseLayout/footer';
import { Search } from '../../../msreact-kit/packages/html-components';
import SupplierDetailsGrid from './supplierDetailsGrid';

// Actions
import { getAllSupplierDetailsWithPagination } from '../../../actions/backoffice-service-action';

// Utils
import Loader from '../../../components/Shared/Utils/Loader';
import { setCountryName } from './utils';

// Data
import { REGION } from '../../../data/idConstants';


// Css
import './index.scss';

const SupplierManagement = memo((props) => {
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const { supplierDetailsList, countryList, content, loader } = useSelector(
        (state) => ({
        supplierDetailsList: state.UserServiceReducer.supplierDetailsList,
        countryList: state.CountryReducer.countryList,
        content: state.ContentReducer.content,
        loader: state.OrderSummaryReducer.isLoading
        })
    );
    const supplierContent = content?.components?.user_management?.supplier_management;

    useEffect(() => {
        dispatch(getAllSupplierDetailsWithPagination(search, currentPage, pageSize));
    }, [search, currentPage, pageSize]);

    const supplierTableDetails = useMemo(() => 
        supplierDetailsList?.content?.map(supplier => ({
            supplierId: supplier.supplierId,
            companyName: supplier.supplierName,
            ...(process.env.REACT_APP_REGION === REGION.IN.CODE 
                ? { gst: supplier.taxIdentifier } 
                : { vat: supplier.taxIdentifier }),
            country: setCountryName(supplier.countryCode, countryList),
            actions: ['View More', 'Edit']
        })), 
        [supplierDetailsList, countryList]
    );

    const handleButtonClick = React.useCallback((event, supplierId, companyName) => {
        const mode = event.currentTarget.id;
        props.history.push({
            pathname: '/dashboard/user/supplier',
            state: {
                supplierId: supplierId,
                supplierName: companyName
            },
            search: `?mode=${mode}`
        });
    }, [props.history]);

    const onSearch = React.useCallback((value) => {
        setSearch(value);
    }, []);

    return (
        <>
            {loader && <Loader />}
                <div className='supplier-management__container'>
                    <div className='supplier-management__container__title-wrapper'>
                        <div className={'supplier-management__container__title'}>
                            <h5 className={'supplier-management__container__header -size-l'}>
                            {supplierContent?.title}
                        </h5>
                            <div className={'supplier-management__container__text'}>
                                <p>
                            {supplierContent?.description}
                        </p>
                            </div>
                        </div>
                        <div  className='supplier-management__grid'>
                            <div className='supplier-management__search'>
                                <Search placeholder={content?.constants?.search} onSearch={onSearch} />
                            </div>
                            <PrimaryButton
                                id='add'
                                label=''
                                onClick={(event) => handleButtonClick(event)}
                                className='supplier-management__add-button'
                            >
                                <span className='a-button__label'>
                                    {'+'}{' '}
                                    <span className='d-sm-none'>
                                        {supplierContent?.supplier_details?.add?.title}
                                    </span>
                                </span>

                            </PrimaryButton>
                        </div>
                    </div>
                    <div className='supplier-management__table'>
                    <SupplierDetailsGrid
                            data={supplierTableDetails}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onPageChange={setCurrentPage}
                            onPageSizeChange={setPageSize}
                            onClick={handleButtonClick}
                            content={supplierContent}
                            totalPages={supplierDetailsList?.totalPages}
                            supplierDetailsList={supplierDetailsList}
                        />
                    </div>
                </div>
                <Footer customClassName='d-lg-none' />
        </>
    );
});

export default SupplierManagement;